<template>
  <div>
    <the-nav-bar :title="$t('statistics.setTime')" />
    <div class="body-item">
      <div
        class="field-item row-justify-center"
        @click="showDatePicker('start')"
      >
        <div class="field-item-title">{{ $t('statistics.startAt') }}</div>
        <div class="field-item-content">{{ startTime | formatTime }}</div>
        <div class="field-item-right row-center">
          <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
        </div>
      </div>
      <div class="field-item row-justify-center" @click="showDatePicker('end')">
        <div class="field-item-title">{{ $t('statistics.endAt') }}</div>
        <div class="field-item-content">{{ endTime | formatTime }}</div>
        <div class="field-item-right row-center">
          <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
        </div>
      </div>
    </div>
    <md-date-picker
      ref="datePicker"
      v-model="isDatePickerShow"
      :key="`${type}-${key}`"
      :keep-index="true"
      :title="title"
      :custom-types="['yyyy', 'MM', 'dd']"
      :min-date="new Date('2021/10/1')"
      :max-date="new Date()"
      :line-height="lineHeight"
      :text-render="textRender"
      :cancel-text="$t('common.cancel')"
      :ok-text="$t('common.confirm')"
      :default-date="defaultValue"
      @confirm="onDateComfirm"
    ></md-date-picker>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import moment from 'moment';
import { DatePicker, Icon } from 'mand-mobile';
import { mapState } from 'vuex';
export default {
  components: { TheNavBar, [Icon.name]: Icon, [DatePicker.name]: DatePicker },
  data() {
    return {
      startTime: '',
      endTime: '',
      isDatePickerShow: false,
      type: '',
      key: 0,
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
    };
  },
  filters: {
    formatTime(unix, template = 'YYYY/MM/DD') {
      return moment(+unix).format(template);
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
    }),
    title() {
      return this.type === 'start'
        ? this.$t('statistics.pickStartTime')
        : this.$t('statistics.pickEndTime');
    },
    defaultValue() {
      return new Date(this.type === 'start' ? +this.startTime : +this.endTime);
    },
    lineHeight() {
      const width = document.documentElement.clientWidth || window.innerWidth;
      return Math.round((width * 9.6) / 100);
    },
  },
  mounted() {
    const orderStatisticTime = window.localStorage.getItem(
      'orderStatisticTime',
    );
    if (orderStatisticTime) {
      [this.startTime, this.endTime] = orderStatisticTime.split('_');
    } else {
      const now = moment().endOf('day');
      this.endTime = +now;
      this.startTime = +now.subtract(7, 'day').startOf('day');
    }
  },
  methods: {
    textRender() {
      if (this.navLang === 'en') {
        const args = Array.prototype.slice.call(arguments);
        const typeFormat = args[0];
        if (typeFormat === 'yyyy' && args[1]) {
          return args[1];
        }
        if (typeFormat === 'MM' && args[2]) {
          return this.months[args[2] - 1];
        }
        if (typeFormat === 'dd' && args[3]) {
          return args[3];
        }
      }
    },
    showDatePicker(type) {
      this.type = type;
      this.isDatePickerShow = true;
    },
    onDateComfirm() {
      const d = this.$refs.datePicker.getFormatDate('yyyy/MM/dd');
      if (this.type === 'start') {
        this.startTime = +new Date(d);
      } else {
        this.endTime = +new Date(d) + 24 * 60 * 60 * 1000 - 1;
      }
      this.key = new Date().getTime();
      this.isDatePickerShow = false;
      window.localStorage.setItem(
        'orderStatisticTime',
        `${this.startTime}_${this.endTime}`,
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 4.8vw 0 60vw;
}

.field-item {
  padding: 0 4.8vw;
  height: 17.07vw;
  font-size: 3.73vw;

  &:nth-child(even) {
    background: #f8fbfc;
  }

  .field-item-title {
    flex: 0 0 32vw;
    font-weight: bold;
  }

  .field-item-content {
    width: 58.4vw;
    text-align: right;
    color: #1b6fdc;
    word-ellipsis();

    &.inactive {
      color: #bcc7cb;
    }
  }
}
</style>
